import React from 'react';
import { IconButton, ImageList, ImageListItem, styled } from '@mui/material';
import { Delete, UploadFile } from '@mui/icons-material';


const StyledImageList = styled(ImageList)(({ theme }) => ({
    gridAutoFlow: 'column',
    gridTemplateColumns: 'repeat(auto-fill,minmax(80px,1fr)) !important',
    gridAutoColumns: 'minmax(80px, 1fr)',

    '.no-preview': {
        backgroundColor: theme.palette.grey['100'],
        padding: 8,

        'div': {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            maxHeight: 72,
        }
    },

    '.MuiIconButton-root': {
        position: 'absolute',
        top: 0,
        right: 0,
    }
}));


type PreviewListProps = {
    attachments: File[],
    remove: (i: number) => void,
}

const PreviewList = ({ attachments, remove }: PreviewListProps) => {
    return (
        <StyledImageList>
            {attachments.map((file, i) => (
                <ImageListItem key={i}>
                    {file.type.includes('image') ?
                        <img alt={file.name} src={URL.createObjectURL(file)}/> :
                        <span className="no-preview">
                            <UploadFile fontSize="large"/>
                            <div>{file.name}</div>
                        </span>
                    }

                    <IconButton
                        onClick={() => remove(i)}
                    >
                        <Delete/>
                    </IconButton>
                </ImageListItem>
            ))}
        </StyledImageList>
    )
};

export default PreviewList;
